import React from 'react';
import "./StatCard.css"
import SingleStat from './SingleStat';
import { getColor } from '../../common/ThemeService';

class StatCard extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const themeColor = getColor()
        const statData = this.props.statData;
        return (
            <div className={"ms_statCard_main " + (this.props.forSwiper ? ' ms_statCard_main_swiper' : '') + (this.props.gameType === 'tournament' ? ' removeCard' : '')}>
                <div className={"ms_card_container " + (this.props.forSwiper ? ' ms_card_container_swiper' : '')}>
                    <div className="ms_card_title">{this.props.i18next.t("lable."+statData.title.toLowerCase())}</div>
                    <div className='ms_blackLine_lite ms_line_margin' style={{ marginTop: "10.65px" }} />
                    {statData.fields && statData.fields.length > 0 ?
                        statData.fields.map((data, index) => {
                            if (this.props.mobileView || index < 4)
                                return (
                                    <SingleStat i18next={this.props.i18next} key={index} data={data} />
                                )
                            else if (index === 4)
                                if (statData.fields && statData.fields.length > 4) {
                                    return (
                                        <div key={index} style={{ display: "flex" }}>
                                            <span
                                                data-toggle="modal"
                                                data-target="#statModal"
                                                onClick={() => this.props.setModalData(statData)}
                                                className='ms_seemore_btn'
                                            ><i className="fa fa-chevron-down" data-e2e="myStats-statsCard-seeMoreButton" 
                                                style={{
                                                    color: themeColor,
                                                }}
                                            /></span>
                                        </div>
                                    )
                                } else {
                                    return (
                                        <SingleStat i18next={this.props.i18next} index={index} data={data} />
                                    )
                                }
                            else
                                null
                        })
                        : <div> {this.props.i18next.t("lable.noData")}</div>
                    }
                </div>
            </div>
        )
    }
}

export default StatCard;


/** WEBPACK FOOTER **
 ** ./src/components/MyStatistics/StatCard.js
 **/